import axios from 'axios';
const CancelToken = axios.CancelToken;
let cancel;

export const fetchPickups = async (welletContext, showId, transferType, fromPickupId) => {
  try {
    cancel && cancel('Cancel previous ');

    const response = await welletContext.apis.tickets
      .get('/transfer/GetPickups', {
        params: {
          showId,
          transferType,
          fromPickupId,
        },
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        }),
      })
      .catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          return null;
        } else {
          return null;
        }
      });

    if (response === null) {
      return;
    }
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return null;
    }
    throw error;
  }
};

export const fetchProductTransfer = async (welletContext, showId, fromZoneId, toZoneId, paxs, transferType, lang) => {
  try {
    cancel && cancel('Cancel previous ');

    const response = await welletContext.apis.tickets
      .get('/transfer/getproducts', {
        params: {
          showId,
          fromZoneId,
          toZoneId,
          paxs,
          transferType,
          lang,
        },
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        }),
      })
      .catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          return null;
        } else {
          return null;
        }
      });

    if (response === null) {
      return;
    }
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return null;
    }
    throw error;
  }
};